import { CaretDownIcon } from '@phosphor-icons/react'
import styled, { css } from 'styled-components'

export const MainContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: ${props => `${props.theme.spacing.sp8}`};
  padding-left: ${props => `${props.theme.spacing.sp4}`};
`

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${props => props.theme.spacing.sp8};
  width: 100%;
  ${props =>
    props.hasMultipleStores &&
    css`
      cursor: pointer;
    `}
`

export const StoreSelectorContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding-right: ${props => props.theme.spacing.sp8};
  max-width: 142px;
`

export const StoreDomainContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp4};
  justify-items: center;
  opacity: ${props => (props.showMenu ? 1 : 0)};
  transition: opacity 0.25s ease-in-out;

  a {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`

export const CustomCaretDownIcon = styled(CaretDownIcon)`
  margin-right: ${props => props.theme.spacing.sp4};
  transition: transform 0.3s;

  ${props =>
    props.isOpen &&
    css`
      transform: rotate(180deg);
    `}
`

export const SearchContainer = styled.div`
  padding: ${props => props.theme.spacing.sp16};
  width: 348px;
`

export const StoresContainer = styled.div`
  max-height: 500px;
  overflow-y: auto;
`

export const SelectedStoreLogo = styled.img`
  max-width: ${props => props.theme.size.L};
  max-height: ${props => props.theme.size.L};
  border-radius: 50%;
  object-fit: contain;
  aspect-ratio: 1/1;
`
